/**
 * Sposób wprowadzenia paczki wybrany przy `resolve`. Wariant z aneksem wymaga
 * niepustej listy `amendmentTourConsentIds` — bez niej backend odrzuca żądanie
 * (`ResolveBookingChangeUseCase`).
 */
export enum ChangeResolution {
  APPLY_NOW = 'APPLY_NOW',
  CLIENT_ACCEPTANCE = 'CLIENT_ACCEPTANCE',
  CLIENT_ACCEPTANCE_WITH_AMENDMENT = 'CLIENT_ACCEPTANCE_WITH_AMENDMENT',
}
